import Vue, { PluginObject } from 'vue';
import component from './NationalityAvatar.vue';

export default {
  install(app: typeof Vue): void {
    app.component('NationalityAvatar', component);
  },
} as PluginObject<any>;

export const NationalityAvatar = component;
